import { useUser } from './useUser';

export function useUserTimezone() {
  const user = useUser();
  return user?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone;
}
